<span class="top-nav-header">
  <div class="left-header">
    <!-- Hamburger menu -->
    <div
      class="hamburger-menu"
      (click)="toggleDrawer()"
      onkeypress="toggleDrawer()"
    >
      <img
        type="image"
        id="hamburger"
        alt="hamburger"
        class="toggle-icon"
        [src]="IMAGES.HAMBURGER"
      />
    </div>

    <!-- App logo/name-->
    <div class="logo-container">
      <img [src]="IMAGES.GSL" class="logo" alt="logo" />
      <span id="text" class="app-name">
        {{
          currentUser?.sciIndicator === 1
            ? DISPLAY.APP_NAME_SCI
            : DISPLAY.APP_NAME
        }}
      </span>
    </div>
  </div>
  @if (authService.allowDrawerToggle()) {
    <div class="right-header">
      <!-- Profile Details -->
      <ion-buttons class="button-container">
        <!-- Groups -->
        <ion-button
          id="text"
          [matMenuTriggerFor]="groupMenu"
          [disabled]="!userProfileUtils.canEditUserLocationGroup(userRole)"
          (click)="openLocationGroup()"
        >
          <div slot="start" id="button-text">
            {{ DISPLAY.GROUP_TEXT }}:
            {{
              currentLocation ? currentLocation.groupCode : DISPLAY.LOADING_TEXT
            }}
          </div>
          @if (
            currentLocation &&
            userProfileUtils.canEditUserLocationGroup(userRole)
          ) {
            <ion-icon
              [src]="IMAGES.ARROW_DOWN"
              class="arrow-down"
              slot="end"
            ></ion-icon>
          }
        </ion-button>

        <mat-menu #groupMenu="matMenu" yPosition="below">
          <ng-template matMenuContent>
            <div
              class="menu-search"
              (click)="$event.stopPropagation()"
              (mousedown)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
            >
              <ion-item
                class="header-custom-search"
                lines="none"
                [class.has-query]="groupSearch"
              >
                <ion-button slot="start" fill="clear">
                  <ion-icon
                    class="search-icon"
                    [src]="IMAGES.SEARCH"
                  ></ion-icon>
                </ion-button>

                <ion-input
                  #locationGroupSearch
                  class="topnav-group-search-input"
                  [placeholder]="DISPLAY.SEARCH || 'Search'"
                  [(ngModel)]="groupSearch"
                ></ion-input>
              </ion-item>
            </div>

            @for (
              group of locationGroups | filterByCode: groupSearch;
              track group
            ) {
              <button
                mat-menu-item
                id="dropdown-button"
                (click)="handleGroupChange(group.code)"
              >
                {{ group.code }}
              </button>
            }
          </ng-template>
        </mat-menu>
        <!----------------------->

        <!-- Sites -->
        <ion-button
          id="text"
          [matMenuTriggerFor]="siteMenu"
          [disabled]="!userProfileUtils.canEditUserLocation(userRole)"
          (click)="openLocation()"
        >
          <div slot="start" id="button-text">
            {{ DISPLAY.LOCATION_TEXT }}:
            {{
              currentLocation
                ? currentLocation.location?.locationDetails?.code
                : DISPLAY.LOADING_TEXT
            }}
          </div>
          @if (
            currentLocation && userProfileUtils.canEditUserLocation(userRole)
          ) {
            <ion-icon
              [src]="IMAGES.ARROW_DOWN"
              class="arrow-down"
              slot="end"
            ></ion-icon>
          }
        </ion-button>

        <mat-menu #siteMenu="matMenu" yPosition="below">
          <ng-template matMenuContent>
            <div
              class="menu-search"
              (click)="$event.stopPropagation()"
              (mousedown)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
            >
              <ion-item
                class="header-custom-search"
                lines="none"
                [class.has-query]="siteSearch"
              >
                <ion-button slot="start" fill="clear">
                  <ion-icon
                    class="search-icon"
                    [src]="IMAGES.SEARCH"
                  ></ion-icon>
                </ion-button>

                <ion-input
                  #locationSearch
                  class="topnav-group-search-input"
                  [placeholder]="DISPLAY.SEARCH || 'Search'"
                  [(ngModel)]="siteSearch"
                ></ion-input>
              </ion-item>
            </div>

            @for (site of linkedSites | filterByCode: siteSearch; track site) {
              <button
                mat-menu-item
                id="dropdown-button"
                (click)="handleLocationChange(site.code)"
              >
                {{ site.code }}
              </button>
            }
          </ng-template>
        </mat-menu>
        <!----------------------->

        <!-- Profile username -->
        <ion-button
          class="profile-name"
          onkeypress="gotoProfile()"
          [disabled]="!canEditProfile"
          (click)="gotoProfile()"
        >
          <ion-icon
            id="profile-icon"
            slot="start"
            [src]="IMAGES.USER_PIN"
          ></ion-icon>
          <div class="user-text" id="text" slot="end">
            {{ userDisplayName() }}
          </div>
        </ion-button>
        <!----------------------->

        <!-- Searchbar -->
        @if (
          permissions.showScreen(
            SCREENS.TRACKINGNUMBERSEARCH,
            userRole,
            currentLocation?.location,
            sciIndicator
          )
        ) {
          <ion-item
            class="header-custom-searchbar"
            lines="none"
            [class.has-query]="searchQuery"
          >
            @if (!searchQuery) {
              <ion-button slot="start" fill="clear">
                <ion-icon class="search-icon" [src]="IMAGES.SEARCH"></ion-icon>
              </ion-button>
            }
            <ion-input
              class="topnav-tracking-number-input"
              [placeholder]="DISPLAY.SEARCH_BAR_PLACEHOLDER"
              [maxlength]="18"
              [(ngModel)]="searchQuery"
              (keypress)="pressKey($event)"
              (onPaste)="paste()"
            ></ion-input>
            @if (searchQuery) {
              <ion-button
                onkeypress="searchQuery = ''"
                slot="end"
                fill="clear"
                (click)="searchQuery = ''"
              >
                <ion-icon
                  slot="icon-only"
                  class="close-icon"
                  [src]="IMAGES.CLOSE_SVG"
                ></ion-icon>
              </ion-button>
            }
          </ion-item>
          <!----------------------->

          <!-- Small Screen Search -->
          @if (!searchQuery) {
            <ion-button
              class="small-search"
              slot="icon-only"
              (click)="openPackageTrackingPopup()"
            >
              <ion-icon class="search-icon" [src]="IMAGES.SEARCH"></ion-icon>
            </ion-button>
          }
        }
      </ion-buttons>
    </div>
  }
</span>
